// extracted by mini-css-extract-plugin
export default {"wrapper":"FfSSqJdC9SMlVuUN3SfS","navigation":"LQVv4qjSEf8nY_mq4Ley"};